import dayjs from "dayjs"
import get from "lodash.get"
import {
	getClientContact,
	serializeClientFacts,
	serializeClientAddresses
} from "@/utils/"

export default (ctx, payload) => {
	const header = schema(ctx, payload).map(item => item.label)
	const body = payload.map(data => schema(ctx).map(y => [y.data(data)]))
	const workSheetData = [header, ...body]
	const workSheetColumns = schema(ctx).map(item => {
		return { wpx: 150 }
	})
	return { workSheetData, workSheetColumns }
}

const schema = ctx => [
	{ label: "Name", data: item => get(item, "name") },
	{
		label: "Registration Number",
		data: item => get(item, "registrationNumber")
	},
	{ label: "Nature of Business", data: item => get(item, "natureOfBusiness") },
	{ label: "Email", data: item => getClientContact("email", item.contacts) },
	{
		label: "Phone",
		data: item => getClientContact("telephoneNumber", item.contacts)
	},
	{ label: "Fax", data: item => getClientContact("fax", item.contacts) },
	{
		label: "WhatsApp",
		data: item => getClientContact("whatsapp", item.contacts)
	},
	{ label: "WeChat", data: item => getClientContact("wechat", item.contacts) },
	{ label: "Web", data: item => getClientContact("web", item.contacts) },
	{
		label: "Addresses",
		data: item => serializeClientAddresses(item.addresses)
	},
	{ label: "Facts", data: item => serializeClientFacts(item.facts) },
	{
		label: "Created",
		data: item =>
			item.createdAt
				? dayjs(item.createdAt).format(ctx.settings.dateTimeFormat)
				: null
	}
]
